module.exports = __webpack_public_path__ + "static/images/warning-yellow.d41aac4b7be3a1f7da0bdbd9bf86743d.svg";